import {
  type AppId,
  type AppListInput,
  type AppScriptId,
  type CompanyId,
  type ConnectLogsInput,
  type ConnectMetricsInput,
  type InstallId,
  type InstallListInput,
  isDefined,
  type Semver,
} from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const CONNECT_VERSION_KEY = 'connect-version'
export const CONNECT_INSTALL_COUNT_KEY = 'connect-install-count'
export const CONNECT_INSTALL_SECRET_KEY = 'connect-install-secret'

export const connectAppListKey = (input?: AppListInput): QueryKey =>
  isDefined(input) ? ['connect-apps', input] : ['connect-apps']
export const connectAppKey = (appId?: AppId): QueryKey => ['connect-app', appId]
export const connectMetricsKey = (input?: ConnectMetricsInput): QueryKey => ['connect-metrics', input]
export const connectLogsInfiniteKey = (input?: Omit<ConnectLogsInput, 'nextToken'>): QueryKey => [
  'connect-logs-infinite',
  input,
]
export const connectVersionKey = (appId?: AppId, appVersion?: Semver): QueryKey => [
  'connect-version',
  appId,
  appVersion,
]
export const connectScriptKey = (scriptId?: AppScriptId): QueryKey => ['connect-script', scriptId]
export const connectInstallListKey = (input?: InstallListInput): QueryKey =>
  isDefined(input) ? ['connect-installs', input] : ['connect-installs']
export const connectInstallKey = (installId?: InstallId): QueryKey => ['connect-install', installId]
export const connectInstallSecretKey = (installId?: InstallId): QueryKey => ['connect-install-secret', installId]
export const connectInstallCountKey = (appId?: AppId, companyId?: CompanyId): QueryKey => [
  'connect-install-count',
  appId,
  companyId,
]
